import { styled as muiStyled } from '@material-ui/core';

const Container = muiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
}));

export default Container;
